// @flow

import {GET} from '../helpers/request';

import type {
  ErrorDto,
} from '../dtos';

export const DATA_REQUEST = '@purchaseReportView/DATA_REQUEST';
export const DATA_SUCCESS = '@purchaseReportView/DATA_SUCCESS';
export const DATA_FAILURE = '@purchaseReportView/DATA_FAILURE';

export const FILTER = '@purchaseReportView/FILTER';

type PurchaseReportDataRequestAction = {
  type: '@purchaseReportView/DATA_REQUEST'
};

export type Entity = {
  id: number,
  name: string
};

export type Apartment = {
  id: number,
  objectId: string,
};

export type Project = Entity & {
  apartments: Apartment[]
};

export type Data = {
  projects: Project[],
  suppliers: Entity[]
};

type PurchaseReportDataSuccessAction = {
  type: '@purchaseReportView/DATA_SUCCESS',
  data: Data
};

type PurchaseReportDataFailureAction = {
  type: '@purchaseReportView/DATA_FAILURE',
  error: ErrorDto
};

type PurchaseReportFilterAction = {
  type: '@purchaseReportView/FILTER',
  apartmentIds: number[],
  projectId: ?number,
  supplierId: ?number,
  includePlans: boolean,
  linebreakPerApartment: boolean,
};

export type PurchaseReportAction
  = PurchaseReportDataRequestAction
  | PurchaseReportDataSuccessAction
  | PurchaseReportDataFailureAction
  | PurchaseReportFilterAction;

export const dataRequest = (): PurchaseReportDataRequestAction => ({
  type: DATA_REQUEST,
});

export const dataSuccess = (data: Data): PurchaseReportDataSuccessAction => ({
  type: DATA_SUCCESS,
  data,
});

export const dataError = (error: ErrorDto): PurchaseReportDataFailureAction => ({
  type: DATA_FAILURE,
  error,
});

export const applyFilter = (apartmentIds: number[], projectId: ?number, supplierId: ?number, includePlans: boolean, linebreakPerApartment: boolean): PurchaseReportFilterAction => ({
  type: FILTER,
  apartmentIds,
  projectId,
  supplierId,
  includePlans,
  linebreakPerApartment,
});

export const fetchData = () => async (dispatch: PurchaseReportAction => void) => {
  dispatch(dataRequest());
  try {
    const data = await GET({endpoint: '/dataexports/purchasereport'}, dispatch);
    dispatch(dataSuccess(data));
  } catch (err) {
    dispatch(dataError(err));
  }
};



// WEBPACK FOOTER //
// ./src/actions/purchaseReportView.js